var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-component-container"},[_c('div',{staticClass:"side-bar-web"},[_c('SideWeb',{staticClass:"web"})],1),_c('div',{staticClass:"side-bar-mobile",class:{ 'show-menu': _vm.showMenu }},[_c('SideMob')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }